<template>
  <b-modal v-model="modal" :title="title" size="lg" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="editCupom()" autocomplete="off">
          <div class="row">
            <div class="col-sm-3">
              <div class="form-group">
                <label for="qtd">Código</label>
                <input
                  id="cupom"
                  v-model="cupon.cupom"
                  name="cupom"
                  type="text"
                  disabled
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="discount">Desconto</label>
                <money
                  class="form-control text-right"
                  v-model="discount"
                  v-bind="money"
                  :class="{
                    'is-invalid': submitted && $v.cupon.discount.$error
                  }"></money>
                <div
                  v-if="submitted && !$v.cupon.discount.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="manager">Responsável</label>
                <input
                  id="manager"
                  v-model="cupon.manager"
                  name="manager"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.cupon.manager.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.cupon.manager.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="description">Descrição</label>
                <input
                  id="description"
                  v-model="cupon.description"
                  name="description"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.cupon.description.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.cupon.description.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="editCupom()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { Money } from 'v-money'

export default {
  components: {
    Loading,
    Money
  },
  props: {
    idCupon: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      title: 'Editar Cupom de Desconto',
      loading: true,
      fullPage: true,
      submitted: false,
      cupon: {},
      modal: false,
      discount: 0.00,
      money: {
        decimal: '.',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    }
  },
  validations: {
    cupon: {
      description: { required },
      discount: { required },
      manager: { required }
    }
  },
  methods: {
    ...mapActions('cupon', {
      getCupon: 'show',
      postData: 'save'
    }),
    loadItem (id) {
      if (id) {
        this.title = 'Editar Cupom de Desconto'
        this.getCupon(id).then((data) => {
          this.cupon = this.data
          this.discount = this.cupon.discount
          // this.cupon.amount = this.data.amount.toString(2)
        }).then(() => {
          this.loading = false
        })
      }
    },
    open (id = null) {
      this.modal = true
      this.loading = true
      if (id) {
        this.loadItem(id)
        return
      }
      this.loading = false
    },
    async editCupom () {
      this.cupon.discount = this.discount
      this.submitted = true
      this.$v.cupon.$touch()
      if (this.$v.cupon.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      await this.postData(this.cupon).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.cupon = {}
      this.$v.$reset()
    }
  },
  computed: {
    ...mapState('cupon', { data: 'cupon' })
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
</style>
